import React from "react";
import * as PropTypes from "prop-types";
import {MasterDataService} from "../../services/MasterDataService";
import {ProvidersService} from "../../services/ProvidersService";
import {Box, TextField, InputAdornment, Link, Typography} from "@mui/material";
import EmailFormatCustom from "../../components/formatters/EmailFormatCustom";
import PhoneNumberFormatCustom from "../../components/formatters/PhoneNumberFormatCustom";
import ZipCodeFormatCustom from "../../components/formatters/ZipCodeFormatCustom";
import { getBaseUrl, buildPublicProfileUrl } from "../../utils/publicProfileUrl";

//import {PhotoAlbumModal} from "../../components/PhotoAlbumModal";
//Add modal functionality to this page Harder than I thought

// Re-export buildPublicProfileUrl for backward compatibility with tests
export { buildPublicProfileUrl } from "../../utils/publicProfileUrl";

const textFieldStyle = {marginBottom: "10px", marginTop: "10px", marginRight: "20px", background: "white"};

/**
 * Render the Public Profile URL helper text.
 * Shows a clickable link to the full URL if friendlyUrl is set, otherwise shows just the guidance.
 */
function renderPublicProfileUrlHelper(baseUrl, friendlyUrl) {
    const guidance = 'Use lowercase letters, numbers, and hyphens only.';

    if (!friendlyUrl) {
        return <span>{guidance}</span>;
    }

    const fullUrl = buildPublicProfileUrl(baseUrl, friendlyUrl);
    return (
        <>
            {'Public profile URL: '}
            <Link
                href={fullUrl}
                target="_blank"
                rel="noopener noreferrer"
                sx={{ color: 'primary.main', textDecoration: 'underline' }}
            >
                {fullUrl}
            </Link>
            {`. ${guidance}`}
        </>
    );
}



export class GeneralTab extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            provider: props.provider,
            services: [],
            categories: [],
            fields: {},
            errors: {
                name: "",
                address: "",
                city: "",
                state: "",
                postalCode: "",
                email: "",
                phoneNumber: "",
                shortDescription: "",
                businessSummary: "",
                friendlyUrl: "",
                websiteUrl: ""
            },
        };
    }


    // openModal() {
    //     this.props.setShowModal(true);
    // }

    componentDidMount() {
        MasterDataService.getAllCategories().then((response) => this.setState({categories: response}));
    }

    handleChange = evt => {
        const { name } = evt.target;
        const value = name === "friendlyUrl"
            ? evt.target.value
                .replace(/[\s_]+/g, "-")
                .replace(/[^A-Za-z0-9-]/g, "")
                .replace(/-+/g, "-")
                .replace(/^-+/, "")
                .toLowerCase()
            : evt.target.value;
        const { provider } = this.state;

        let newProvider ={
            ...provider,
            [name]: value
        }
        this.props.setProvider(newProvider);
        // Update provider state
        this.setState({
            provider:
                newProvider

        });

        const usZipCodeRegEx = new RegExp('^[0-9]{5}$');
        const emailRegex = new RegExp('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,}$');

        // Validate and update errors state
        let errorMessage = "";
        switch (name) {
            case "name":
                errorMessage = value ? "" : "Name is required";
                break;
            case "friendlyUrl":
                errorMessage = value ? "" : "Friendly URL is required";
                break;
            case "websiteUrl":
                try {
                    if (value) {
                        new URL(value);
                    }
                    errorMessage = "";
                } catch {
                    errorMessage = "Website URL must be a valid URL";
                }
                break;
            case "address":
                errorMessage = value ? "" : "Address is required";
                break;
            case "city":
                errorMessage = value ? "" : "City is required";
                break;
            case "state":
                errorMessage = value ? "" : "State is required";
                break;
            case "postalCode":
                errorMessage = usZipCodeRegEx.test(value) ? "" : "Postal Code is required";
                console.log(value);
                break;
            case "email":
                errorMessage = emailRegex.test(value) ? "" : "Email is required";
                break;
            case "phoneNumber":
                errorMessage = value ? "" : "Phone Number is required";
                break;
            case "businessSummary":
                errorMessage = value ? "" : "A Summary is required";
                break;
            default:
                break;
        }

        // Update errors state
        this.setState(prevState => ({
            errors: {
                ...prevState.errors,
                [name]: errorMessage
            }
        }));


    };

    handleFriendlyUrlBlur = () => {
        const { provider } = this.state;
        if (!provider || !provider.friendlyUrl) {
            return;
        }

        const trimmedValue = provider.friendlyUrl.replace(/-+$/, "");
        if (trimmedValue !== provider.friendlyUrl) {
            const newProvider = {
                ...provider,
                friendlyUrl: trimmedValue
            };
            this.props.setProvider(newProvider);
            this.setState({
                provider: newProvider
            });
        }
    };

    onSaveButtonClick() {
        ProvidersService.updateProvider(this.state.provider).then(r => console.log(r));
    }

    render() {
        return <Box sx={{ p: '5px', pb: '25px' }}>
                <Typography variant="h6" gutterBottom sx={{ mb: 3 }}>
                    General
                </Typography>

                   {/* <div
                        className="camera-button labels"
                        style={{display: "flex", alignItems: "center"}}
                        id="thumbnail-image"
                        onClick={this.openModal}
                    >
                        <img src={require("../../assets/camera-icon.png")} alt="camera icon"/>

                    </div> */}

                    <TextField
                        sx = {textFieldStyle}
                        fullWidth={true}
                        label = "Name"
                        name="name"
                        varient={"outlined"}
                        onChange={this.handleChange}
                        value={this.state.provider?.name}/>
                {this.state.errors.name && (
                    <div style={{ color: "red" }}>{this.state.errors.name}</div>
                )}
                    <TextField
                        sx = {textFieldStyle}
                        fullWidth={true}
                        label = "Friendly URL"
                        name="friendlyUrl"
                        varient={"outlined"}
                        onChange={this.handleChange}
                        onBlur={this.handleFriendlyUrlBlur}
                        value={this.state.provider?.friendlyUrl || ""}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start" sx={{ color: 'text.secondary', mr: 0 }}>
                                    {`${getBaseUrl()}/`}
                                </InputAdornment>
                            ),
                        }}
                        helperText={renderPublicProfileUrlHelper(getBaseUrl(), this.state.provider?.friendlyUrl)}
                    />
                {this.state.errors.friendlyUrl && (
                    <div style={{ color: "red" }}>{this.state.errors.friendlyUrl}</div>
                )}
                    <TextField
                        sx = {textFieldStyle}
                        fullWidth={true}
                        label = "External Website"
                        name="websiteUrl"
                        varient={"outlined"}
                        onChange={this.handleChange}
                        value={this.state.provider?.websiteUrl || ""}
                        helperText="External website shown on the public provider details page."/>
                {this.state.errors.websiteUrl && (
                    <div style={{ color: "red" }}>{this.state.errors.websiteUrl}</div>
                )}
                    <TextField
                        sx = {textFieldStyle}
                        fullWidth={true}
                        label = "Address"
                        name="address"
                        varient={"outlined"}
                        onChange={this.handleChange}
                        value={this.state.provider?.address}/>
                {this.state.errors.address && (
                    <div style={{ color: "red" }}>{this.state.errors.address}</div>
                )}
                    <TextField
                        sx = {textFieldStyle}
                        fullWidth={true}
                        label = "City"
                        name="city"
                        varient={"outlined"}
                        onChange={this.handleChange}
                        value={this.state.provider?.city}/>
                {this.state.errors.city && (
                    <div style={{ color: "red" }}>{this.state.errors.city}</div>
                )}
                    <TextField
                        sx = {textFieldStyle}
                        fullWidth={true}
                        label = "State"
                        name="state"
                        varient={"outlined"}
                        onChange={this.handleChange}
                        value={this.state.provider?.state}/>
                {this.state.errors.state && (
                    <div style={{ color: "red" }}>{this.state.errors.state}</div>
                )}
                    <TextField
                        sx = {textFieldStyle}
                        fullWidth={true}
                        label = "Zip Code"
                        name="postalCode"
                        InputProps={{
                            inputComponent: ZipCodeFormatCustom,
                        }}
                        varient={"outlined"}
                        onChange={this.handleChange}
                        value={this.state.provider?.postalCode}/>
                {this.state.errors.postalCode && (
                    <div style={{ color: "red" }}>{this.state.errors.postalCode}</div>
                )}
                    <TextField
                        sx = {textFieldStyle}
                        fullWidth={true}
                        label = "Email"
                        name="email"
                        InputProps={{
                            inputComponent: EmailFormatCustom,
                        }}
                        varient={"outlined"}
                        onChange={this.handleChange}
                        value={this.state.provider?.email}/>
                {this.state.errors.email && (
                    <div style={{ color: "red" }}>{this.state.errors.email}</div>
                )}
                    <TextField
                        sx = {textFieldStyle}
                        fullWidth={true}
                        label = "Phone Number"
                        name="phoneNumber"
                        InputProps={{
                            inputComponent: PhoneNumberFormatCustom,
                        }}
                        varient={"outlined"}
                        onChange={this.handleChange}
                        value={this.state.provider?.phoneNumber}/>
                {this.state.errors.phoneNumber && (
                    <div style={{ color: "red" }}>{this.state.errors.phoneNumber}</div>
                )}
 {/*                   <div>
                        <label className="labels">Service Areas
                            <input type="text" name="service-area" onChange={this.handleDescriptionChanged.bind(this)}/>
                        </label>
                    </div>

                    <div>
                        <label className="labels">Operating Hours
                            <input type="text" name="op-hours" onChange={this.handleDescriptionChanged.bind(this)}/>
                        </label>
                    </div>*/}
                    <TextField
                        sx={textFieldStyle}
                        fullWidth={true}
                        multiline
                        minRows={2}
                        label="Short Description"
                        name="shortDescription"
                        varient={"outlined"}
                        onChange={this.handleChange}
                        value={this.state.provider?.shortDescription || ""}/>
                {this.state.errors.shortDescription && (
                    <div style={{ color: "red" }}>{this.state.errors.shortDescription}</div>
                )}
                    <TextField
                        multiline
                        minRows={5}
                        fullWidth={true}
                        sx = {textFieldStyle}
                        label = "Business Summary"
                        name="businessSummary"
                        varient={"outlined"}
                        onChange={this.handleChange}
                        value={this.state.provider?.businessSummary}/>
                {this.state.errors.businessSummary && (
                    <div style={{ color: "red" }}>{this.state.errors.businessSummary}</div>
                )}
                    {/* <div>
                        <label className="labels">Upload the image you want to appear when your business is searched
                            for<br/>
                            <input type="file" name="search-result-image" accept="image/*" multiple={false}/>
                             Set Search Result Image
                        </label>
                    </div> */}

                {/*<label>*/}
                {/*    <Button  variant={"outlined"}  onClick={this.onSaveButtonClick.bind(this)}>Save</Button>*/}
                {/*</label>*/}
        </Box>;
    }
}


const providerPropType = PropTypes.shape({
    id: PropTypes.string.isRequired,
    friendlyUrl: PropTypes.string,
    websiteUrl: PropTypes.string,
    name: PropTypes.string.isRequired,
    address: PropTypes.string.isRequired,
    city: PropTypes.string.isRequired,
    state: PropTypes.string.isRequired,
    postalCode: PropTypes.string.isRequired,
    categoryType: PropTypes.string.isRequired,
    phoneNumber: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    thumbnail: PropTypes.string.isRequired,
    thumbnailUrl: PropTypes.string.isRequired,
    rating: PropTypes.number.isRequired,
    shortDescription: PropTypes.string,
    businessSummary: PropTypes.string.isRequired,
    carouselImages: PropTypes.arrayOf(PropTypes.string).isRequired,
    imageList: PropTypes.arrayOf(PropTypes.string).isRequired,
    etag: PropTypes.string.isRequired,
});


GeneralTab.propTypes = {
    onSubmit: PropTypes.func,
    onClick: PropTypes.func,
    setProvider: PropTypes.func.isRequired,
    provider: providerPropType.isRequired,
    onChange: PropTypes.func,
    // setShowModal: PropTypes.func,
    // ShowModal: PropTypes.func
};


